import { differenceInCalendarDays, format, formatDistanceToNowStrict, parseISO } from 'date-fns';

export function fmtSf(value: number | null | undefined): string {
  if (value == null) return '—';
  return new Intl.NumberFormat('en-US').format(value) + ' sf';
}

export function fmtRange(
  min: number | null | undefined,
  max: number | null | undefined
): string {
  if (min == null || max == null) return '—';
  return `${fmtSf(min)} – ${fmtSf(max)}`;
}

export function fmtUsd(cents: number | null | undefined, digits = 2): string {
  if (cents == null) return '—';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(cents);
}

export function fmtInt(value: number | null | undefined): string {
  if (value == null) return '—';
  return new Intl.NumberFormat('en-US').format(value);
}

export function fmtDate(input: number | string | null | undefined): string {
  if (input == null) return '—';
  const d = typeof input === 'number' ? new Date(input) : parseISO(input);
  if (Number.isNaN(d.getTime())) return '—';
  return format(d, 'MMM d, yyyy');
}

export function fmtRelative(input: number | string | null | undefined): string {
  if (input == null) return '—';
  const d = typeof input === 'number' ? new Date(input) : parseISO(input);
  if (Number.isNaN(d.getTime())) return '—';
  return formatDistanceToNowStrict(d, { addSuffix: true });
}

export type DeadlineTier = 'safe' | 'warn' | 'urgent' | 'expired';

export function deadlineTier(
  responseDeadline: number | string | null | undefined
): { tier: DeadlineTier; days: number | null } {
  if (responseDeadline == null) return { tier: 'safe', days: null };
  const d = typeof responseDeadline === 'number' ? new Date(responseDeadline) : parseISO(responseDeadline);
  if (Number.isNaN(d.getTime())) return { tier: 'safe', days: null };
  const days = differenceInCalendarDays(d, new Date());
  if (days < 0) return { tier: 'expired', days };
  if (days < 7) return { tier: 'urgent', days };
  if (days <= 21) return { tier: 'warn', days };
  return { tier: 'safe', days };
}

export function confidenceTier(c: number | null | undefined): 'high' | 'medium' | 'low' {
  if (c == null) return 'low';
  if (c >= 0.85) return 'high';
  if (c >= 0.7) return 'medium';
  return 'low';
}
